"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Checkbox = exports.SuffixIcon = exports.StyledHiddenCheckbox = void 0;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const app_1 = require("@obvio/app");
const react_1 = require("react");
__exportStar(require("./DefaultDropzone"), exports);
__exportStar(require("./InputController"), exports);
__exportStar(require("./InputElements"), exports);
__exportStar(require("./Label"), exports);
__exportStar(require("./aria"), exports);
exports.StyledHiddenCheckbox = app_1.styled.input `
  position: absolute;
  opacity: 0;
  width: 0;
  height: 0;
  pointer-events: none;
`;
function SuffixIcon({ icon: Icon }) {
    const style = (0, react_1.useMemo)(() => (0, app_1.css) `
      height: 1.25rem !important;
      width: unset !important;
      padding: 0 ${(theme) => theme.spacing.small};
      color: ${(theme) => theme.colors.gray.semidark};
    `, []);
    return (0, jsx_runtime_1.jsx)(Icon, { css: style });
}
exports.SuffixIcon = SuffixIcon;
const StyledCheckboxInner = app_1.styled.input `
  --active: ${(theme) => theme.colors.primary};
  --active-inner: transparent;
  --background: transparent;
  --disabled: #eef2fd;
  --disabled-inner: ${(theme) => theme.colors.primary.intense};
  -webkit-appearance: none;
  -moz-appearance: none;
  min-height: 21px;
  min-width: 21px;
  outline: none;
  display: inline-block;
  vertical-align: top;
  position: relative;
  margin: 0;
  cursor: pointer;
  border: 2px solid var(--border, var(--active));
  background: var(--bg, var(--background));
  transition: background 0.3s, border-color 0.3s, box-shadow 0.2s;
  ${app_1.styled.invalid `
    --border: ${(theme) => theme.colors.error};
  `}
  &:after {
    content: '';
    display: block;
    left: 0;
    top: 0;
    position: absolute;
  }
  &:checked {
    --bg: var(--active);
    --border: var(--active);
    --active-inner: #fff;
  }
  &:disabled {
    --bg: var(----active-inner);
    --border: var(--disabled);
    --inactive-inner: var(--disabled)
    cursor: not-allowed;
    opacity: 0.9;
    &:checked {
      --bg: var(--disabled);
      --border: var(--disabled);
      --inactive-inner: var(--disabled-inner);
    }
    & + label {
      cursor: not-allowed;
    }
  }

  & + label {
    font-size: 14px;
    line-height: 21px;
    display: inline-block;
    vertical-align: top;
    cursor: pointer;
    margin-left: 4px;
  }

  &:not(.switch) {
    border-radius: 0.25rem;
    &:after {
      width: 8px;
      height: 11px;
      border: 2px solid var(--inactive-inner, var(--active-inner));
      border-top: 0;
      border-left: 0;
      left: 5px;
      top: 1px;
      transform: rotate(43deg);
    }
  }
  ${(theme) => { var _a; return [(_a = theme.inputs.checkbox) === null || _a === void 0 ? void 0 : _a.css]; }}
`;
function Checkbox(props) {
    return (0, jsx_runtime_1.jsx)(StyledCheckboxInner, Object.assign({ type: "checkbox" }, props));
}
exports.Checkbox = Checkbox;
